import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { successMessage, errorMessage, capitalizeString } from "../CommonFunctions";
import {
  POST_GetEmployeeDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetItemIssueListByEmployeeID,
  POST_GetItemDCInwardNoList,
  POST_ItemDCInsert,
  POST_GetItemDCDetailByID,
  POST_ItemDCUpdate,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

const AddInventoryItemDC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [inwardNumberOptions, setInwardNumberOptions] = useState([]);

  useEffect(() => {
    getEmployeeDDL();
    if (PrimaryIdParam) {
      getItemDCDetailByID();
    }
  }, []);

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const getItemDCInwardNoList = async (CustomerIDEncrypted) => {
    setIsLoading(true);
    post(POST_GetItemDCInwardNoList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInwardNumberOptions(
            response?.List?.map((item) => ({
              label: item.InwardNo,
              value: item.InwardIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const loadOptionsCutomer = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });

  const getCustomerDDL_AJAX = (inputValue) =>
    post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1,
    })
      .then((response) =>
        response?.IsSuccess
          ? response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            }))
          : []
      )
      .catch(() => []);

  const validationSchema = Yup.object().shape({
    IssueToEmployeeIDEncrypted: Yup.string()
      .trim()
      .required("Issue To Employee is required field"),
    CustomerIDEncrypted: Yup.string().required("Customer is required field"),
    DCDate: Yup.string().required("DC Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values) => handleValidSubmit(values),
    initialValues: {
      ItemDCIDEncrypted: "",
      CustomerIDEncrypted: "",
      CustomerName: "",
      DCNo: "",
      InventoryItemIssueIDEncrypted: "",
      InventoryItemStockIDEncrypted: "",
      InventoryItemIDEncrypted: "",
      IssueToEmployeeIDEncrypted: "",
      InwardIDEncrypted: "",
      ListOfItem: [],
      DCDate: new Date(),
      Remarks: "",
      IsDelete: false,
      IsSelected: false,
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: {
      ItemDCIDEncrypted,
      ListOfItem,
      CustomerIDEncrypted,
      CustomerName,
      IssueToEmployeeIDEncrypted,
      DCDate,
    },
  } = formik;

  useEffect(() => {
    if (!DCDate) {
      formik.setFieldValue("DCDate", "");
    }
  }, [DCDate]);

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getItemDCInwardNoList(CustomerIDEncrypted);
    }
  }, [CustomerIDEncrypted]);

  const getItemDCDetailByID = () => {
    setIsLoading(true);
    post(POST_GetItemDCDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      ItemDCIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          const listMapped = response?.List?.map((item) => ({
            InventoryItemIDEncrypted: item?.InventoryItemIDEncrypted,
            InventoryItemStockIDEncrypted:
              item?.InventoryItemStockIDEncrypted ?? "",
            InventoryItemIssueIDEncrypted:
              item?.InventoryItemIssueIDEncrypted ?? "",
            ItemDCDetailsIDEncrypted: item?.ItemDCDetailsIDEncrypted ?? "",
            InwardIDEncrypted: item?.InwardIDEncrypted,
            ItemName: item?.ItemName ?? "",
            SerialNumber: item?.SerialNumber ?? "",
            TotalPendingReturnQty:
              parseInt(item?.TotalPendingReturnQty) + parseInt(item?.IDCQty) ??
              0,
            ConsumptionUnit: item?.ConsumptionUnit ?? "",
            Qty: item?.IDCQty?.toString() ?? "0",
            IsConsumable: item?.IsConsumable ?? false,
            IsSelected: item?.IsSelected,
            IsDelete: item?.IsDelete,
          }));
          formik.setValues({
            DCNo: response?.DCNo ?? "",
            IssueToEmployeeIDEncrypted: response?.EmployeeIDEncrypted,
            ItemDCIDEncrypted: response?.ItemDCIDEncrypted ?? "",
            CustomerIDEncrypted: response?.CustomerIDEncrypted,
            CustomerName: response?.CustomerName,
            DCDate: response?.DCDate ? new Date(response?.DCDate) : "",
            Remarks: response?.Remarks ?? "",
            CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt ?? "0",
            ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt ?? "0",
            ListOfItem: listMapped,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeCustomer = (e) => {
    if (e?.value) {
      formik.setFieldValue("CustomerIDEncrypted", e?.value ?? "");
      formik.setFieldValue("CustomerName", e?.label ?? "");
    } else {
      formik.setFieldValue("CustomerIDEncrypted", "");
      formik.setFieldValue("CustomerName", "");
      // Clear InwardIDEncrypted for all items
      formik.setFieldValue(
        "ListOfItem",
        formik.values.ListOfItem.map((item) => ({
          ...item,
          InwardIDEncrypted: "",
        }))
      );
      setInwardNumberOptions([]); // Also clear dropdown options
    }
  };

  const handleValidSubmit = (values) => {
    if (values?.ListOfItem?.filter((x) => x?.IsSelected).length === 0) {
      formik.setFieldError("ListOfItem", "Please select Item Issue Detail...");
      formik.setFieldTouched("ListOfItem", true);
      return;
    }

    let IsItemValidQty = false;
    let IsItemValid = false;
    let IsItemValidPendingReturnQty = false;

    values?.ListOfItem?.filter((x) => x?.IsSelected)?.forEach((test) => {
      if (!test?.Qty || Number(test?.Qty) <= 0) IsItemValidQty = true;
      if (!test?.InwardIDEncrypted || test?.InwardIDEncrypted === 0)
        IsItemValid = true;
      if (Number(test?.Qty) > Number(test?.TotalPendingReturnQty))
        IsItemValidPendingReturnQty = true;
    });

    if (IsItemValidQty) {
      formik.setFieldError("ListOfItem", "Please enter the Qty...");
      formik.setFieldTouched("ListOfItem", true);
      return;
    }

    if (IsItemValid) {
      formik.setFieldError("ListOfItem", "Please select inward number...");
      formik.setFieldTouched("ListOfItem", true);
      return;
    }

    if (IsItemValidPendingReturnQty) {
      formik.setFieldError(
        "ListOfItem",
        "Qty cannot be greater than Pending Qty."
      );
      formik.setFieldTouched("ListOfItem", true);
      return;
    }

    setIsLoading(true);

    // Clean and minimal payload
    const payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EmployeeIDEncrypted: IssueToEmployeeIDEncrypted,
      CustomerIDEncrypted: values.CustomerIDEncrypted,
      ItemDCIDEncrypted: ItemDCIDEncrypted ? ItemDCIDEncrypted : "",
      DCDate: values.DCDate
        ? moment(values?.DCDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      DCFrom: 1,
      Remarks: values.Remarks,
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt || "0",
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt || "0",
      Listuddt: values.ListOfItem.map((item) => ({
        InventoryItemIssueIDEncrypted: item.InventoryItemIssueIDEncrypted,
        InventoryItemStockIDEncrypted: item.InventoryItemStockIDEncrypted,
        InventoryItemIDEncrypted: item.InventoryItemIDEncrypted,
        ItemDCDetailsIDEncrypted: item.ItemDCDetailsIDEncrypted || "",
        InwardIDEncrypted: item.InwardIDEncrypted,
        SerialNo: item.SerialNo || "",
        Qty: item.Qty,
        IsConsumable: item.IsConsumable,
        IsSelected: item.IsSelected,
        IsDelete: item.IsDelete,
      })),
    };
    console.log("====================================");
    console.log("Payload ", payload);
    console.log("====================================");
    // return;
    post(PrimaryIdParam ? POST_ItemDCUpdate : POST_ItemDCInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/item-dc");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const generateUniqueNumber = () => {
    const now = new Date();
    return moment(now).format("YYYYMMDDHHmmssSSS");
  };

  const GetItemIssueDetail = (id) => {
    formik.setFieldValue("ListOfItem", []);
    setIsLoading(true);
    post(POST_GetItemIssueListByEmployeeID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      IssueToEmployeeIDEncrypted: id,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfItem",
            response?.List?.map((item) => ({
              ...item,
              Qty: item?.Qty > 0 ? item?.Qty : item?.TotalPendingReturnQty,
              IsDelete: false,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Item DC
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    {PrimaryIdParam && (
                      <Col lg={3}>
                        <Field
                          label="DC No"
                          name="DCNo"
                          placeholder={"Enter DC No"}
                          component={CustomInput}
                          required
                          maxLength={100}
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue("DCNo", capitalizeString(e));
                          }}
                          disabled
                        />
                      </Col>
                    )}
                    <Col lg={3}>
                      <Field
                        label="DC Date"
                        name="DCDate"
                        placeholder={"Select DC Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          maxDate: new Date(),
                        }}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Customer"
                        name="CustomerIDEncrypted"
                        placeholder={"Select Customer"}
                        loadOptionsFn={loadOptionsCutomer}
                        component={CustomSelectAsync}
                        title={CustomerName}
                        labelFieldName="CustomerName"
                        required
                        onChange={handleChangeCustomer}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Issue To Employee"
                        name="IssueToEmployeeIDEncrypted"
                        placeholder={"Select Issue To Employee"}
                        options={employeeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                        onChange={(e) => {
                          formik.setFieldValue(
                            "IssueToEmployeeIDEncrypted",
                            e?.value ?? ""
                          );
                          GetItemIssueDetail(e?.value ?? "");
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        name={"Remarks"}
                        label={"Remarks"}
                        placeholder={"Remarks"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <Row>
                    <Col lg={12}>
                      <div className="card-header p-2">
                        <h4 className="card-title">Item DC Detail</h4>
                      </div>
                      <div className="card-body p-1">
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="ItemDetail-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer "
                            style={{ overflowY: "auto" }}
                          >
                            <table
                              id="ItemDetail-tbl"
                              className="table dataTable no-footer mb-0 "
                            >
                              <thead className="fixedheader">
                                <tr>
                                  <th width="3%"></th>
                                  <th width="41%">Item Name</th>
                                  <th width="16%">Serial No</th>
                                  <th width="8%">Pending Qty</th>
                                  <th width="8%">Unit Name</th>
                                  <th width="8%">Qty</th>
                                  <th
                                    style={{ width: "16%", textAlign: "left" }}
                                  >
                                    Inward Number
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfItem?.length > 0 ? (
                                  ListOfItem?.map((item, indx) => (
                                    <tr key={indx}>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkReturn${indx}`}
                                          name={`chkReturn${indx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ListOfItem[${indx}].IsSelected`,
                                              e?.target?.checked
                                            );
                                          }}
                                        />
                                      </td>
                                      <td style={{ whiteSpace: "normal" }}>
                                        {item?.ItemName}
                                      </td>
                                      <td>{item?.SerialNumber}</td>
                                      <td>{item?.TotalPendingReturnQty}</td>
                                      <td>{item?.ConsumptionUnit}</td>
                                      <td>
                                        <Field
                                          type="number"
                                          name={`ListOfItem[${indx}].Qty`}
                                          component={CustomInput}
                                          placeholder="Qty"
                                          noMarginBottom={true}
                                          numberTypeWithoutDot={true}
                                          disabled={!item.IsSelected}
                                        />
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        <Field
                                          name={`ListOfItem[${indx}].InwardIDEncrypted`}
                                          placeholder={"Select Inward No"}
                                          options={inwardNumberOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          value={item.InwardIDEncrypted}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ListOfItem[${indx}].InwardIDEncrypted`,
                                              e?.value ?? ""
                                            );
                                          }}
                                          isDisabled={!item.IsSelected}
                                          menuPosition="fixed"
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={10}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>No Record Found...</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <ErrorMessage
                              name={"ListOfItem"}
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => navigate(-1)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddInventoryItemDC;
